// extracted by mini-css-extract-plugin
module.exports = {"container":"Comment_container__1_nAM","replyActions":"Comment_replyActions__3H6AR","mask":"Comment_mask__27yLK"};